import clsx from "clsx";

import { formatNumber } from "../../../helpers/helpers";
import styles from "./ProgressBar.module.scss";

type ProgressBarProps = {
  min: number;
  /** null means the cap is unlimited (usage-billed plans) */
  max: number | null;
  customText?: string;
  height?: string;
};
const ProgressBar = ({ min, max, customText, height }: ProgressBarProps) => {
  // An unlimited cap (null) has no meaningful progress: show only the
  // usage count, without a bar.
  if (max === null) {
    return (
      <div className="progress-bar">
        <div className={styles.progressText}>{formatNumber(min)} used</div>
      </div>
    );
  }

  const progress = (min / max) * 100;

  return (
    <div className="progress-bar">
      <div className={styles.progressBar}>
        <div
          className={clsx({
            [styles.blue]: progress < 50 && !customText,
            [styles.orange]: progress >= 50 && progress <= 75 && !customText,
            [styles.red]: progress > 75 && !customText,
            [styles.blueCustom]: customText,
          })}
          style={{
            width: `${max >= min ? progress : 100}%`,
            height: height || "8px",
          }}
        ></div>
      </div>
      <div className={styles.progressText}>
        {!customText ? (
          <>
            <span
              className={clsx({
                [styles.redText]: min > max,
              })}
            >
              {formatNumber(min)}
            </span>{" "}
            of {formatNumber(max)} used
          </>
        ) : (
          customText
        )}
      </div>
    </div>
  );
};

export default ProgressBar;
